// utilities
import api from '@/utilities/api'

export const getPerson = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/people/' + payload.personID,
    payload
  })
}
export const createPerson = ({ rootState, commit, dispatch }, payload) => {
  let routePrefix = rootState.person.primaryPerson ? 'private' : 'open'
  return api.request({
    method: 'post',
    endpoint: routePrefix + '/people',
    payload
  })
}
export const login = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'open/people/auth',
    payload,
    success (response) {
      commit('login', response.data)
      commit('setSettings', response.data.settings)
      dispatch('getBaxterBucks', null)
      dispatch('facilities/getCampgrounds', null, { root: true })
      dispatch('facilities/getCampsites', null, { root: true })
    }
  })
}
export const passwordResetRequest = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'open/people/passwordResetRequest',
    payload
  })
}
export const passwordReset = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'open/people/passwordReset',
    payload
  })
}
export const getPersonGroups = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'open/people/groups',
    success (response) {
      commit('setPersonGroups', response.data)
    }
  })
}
export const updatePerson = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/people',
    payload,
    success (response) {
      commit('updatePerson', payload)
    }
  })
}
export const updatePersonNote = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/people/note',
    payload,
    success (response) {
      commit('updatePersonNote', payload.note)
    }
  })
}
export const updatePassword = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/people/password',
    payload,
    success (data) {
    }
  })
}
export const searchPeople = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/people/search',
    payload,
    success (response) {
      commit('setSearchResults', response.data)
    },
    failure (data) {
    }
  })
}
export const setProxyPerson = ({ commit, dispatch }, payload) => {
  // unload user data
  commit('clearData', null, { root: true })
  commit('setProxyPerson', payload)
  dispatch('getBaxterBucks')
}
export const unloadProxyPerson = ({ commit, dispatch }, payload) => {
  // unload user data
  commit('clearData', null, { root: true })
  commit('unloadProxyPerson', payload)
  dispatch('getBaxterBucks')
}
export const getBaxterBucks = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/people/baxterBucks',
    success (response) {
      commit('setBaxterBucks', response.data.baxterBucks)
    }
  })
}
export const changePersonGroup = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/people/group',
    payload,
    success (response) {
      commit('setPersonGroup', payload.personGroupID)
    }
  })
}
export const deletePerson = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/people',
    payload,
    success (response) {
      dispatch('unloadProxyPerson')
    }
  })
}
export const getPersonSettings = ({ state, commit, dispatch }, payload) => {
  let url = state.primaryPerson ? 'private/settings/person' : 'open/settings'
  return api.request({
    method: 'get',
    endpoint: url,
    success (response) {
      commit('setSettings', response.data)
    }
  })
}
